const PATH_SEPARATOR = "/";

export interface IConvertedItem {
    name: string;
    url: string;
}
//  Converts ["/url/:id/page"] to "/url/d2345f234/page" using attrs from paramsArr
export const urlConvertor = (
    pathArr: string[],
    params: Record<string, string>
) => {
    if (!pathArr || !pathArr.length) {
        return [];
    }

    let url: string;
    let name: string;
    let convertedItem: IConvertedItem;
    const convertedArr: IConvertedItem[] = [];
    const keysArr = [...Object.keys(params)];
    const valuesArr = [...Object.values(params)];

    pathArr.forEach((path: string) => {
        url = path;

        keysArr.forEach((_, index) => {
            url = url.replace(":" + keysArr[index], valuesArr[index]);
        });
        valuesArr.forEach((item) => {
            if (url.includes(item)) {
                name = item;
            }
        });

        convertedItem = {
            name: decodeURIComponent(name),
            url: url,
        };

        convertedArr.push(convertedItem);
    });

    return convertedArr;
};

export const getFileName = (url: URL): string =>
    url.pathname.split(PATH_SEPARATOR).pop() || "";

export const setFileName = (url: URL, name: string): URL => {
    const segments = url.pathname.split(PATH_SEPARATOR);
    segments[segments.length - 1] = name;
    url.pathname = segments.join(PATH_SEPARATOR);

    return url;
};
